import { User } from '@us/web/shared/data-access';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { GetAccessTokenResponse, LoginParams, UpdateProfileParams } from '../models';

export const AuthActions = createActionGroup({
    source: 'Auth API',
    events: {
        'Get Token': emptyProps(),
        'Get Token Success': props<{ data: GetAccessTokenResponse }>(),
        Login: props<{ params: LoginParams }>(),
        'Login Success': props<{ user: User; token: GetAccessTokenResponse }>(),
        'Login Failure': props<{ error: string }>(),
        Logout: emptyProps(),
        'Logout Confirmed': emptyProps(),
        'Logout Not Confirmed': emptyProps(),
        'Update Account Profile': props<{
            params: UpdateProfileParams;
            onSuccess?: () => void;
            onFailure?: () => void;
        }>(),
        'Update Account Profile Success': props<{ user: User; token: GetAccessTokenResponse }>(),
        'Update Account Profile Failure': props<{ error: string }>(),
        'Update Session User Name': props<{ name: string }>()
    }
});
